import React from 'react';
import '../../assets/css/modal.css';

const Modal = ({title, modalClassName, className, onConfirm, onClose, confirmLabel, visible, children}) => (
    <div className="modal_wrap" style={{ display: visible ? 'flex' : 'none', zIndex: 9999 }}>
      <div className={`modal ${modalClassName?modalClassName:''}`}>
        <h6>{title}</h6>
        <div className={`modal_body ${className?className:''}`}>
          {children}
        </div>
        <ul className="common_btn">
          {onConfirm && <li className="primary" onClick={onConfirm}>{confirmLabel?confirmLabel:"확인"}</li>}
          {onClose && <li className="tertiary" onClick={onClose}>닫기</li>}
        </ul>
      </div>
    </div>
);

export default Modal;
